import './EntriesArchiveGrid.scss';
class EntriesArchiveGrid {
    constructor( node ) {
        this.node = node;
        this.psObj = null;
    }
    init() {
        let t = this;

        t.node.insertAdjacentHTML( 'beforeend','<div class="EntriesArchiveGrid__mask"></div>' );

        t.node.addEventListener('click', ( event ) => {
            if( event.target.hasAttribute('data-page') ) {
                t.loadContent( event.target.getAttribute('data-page') );
            }
        });
        if( typeof JSModules['PsInit'] != 'undefined' && JSModules['PsInit'] ) {
            t.psObj = new JSModules['PsInit']( t.node );
        }

        // -- horizontal image load -- //
            if( t.node.classList.contains('EntriesArchiveGrid__mobile--carousel') ) {
                let observerLoad = new IntersectionObserver(
                    ( entries, settings ) => {
                        entries.forEach( ( entry, index ) => {
                            if( entry.isIntersecting ) {
                                window.theme.lazyObj.loadSingleImage( entry.target );
                                observerLoad.unobserve( entry.target );
                            }
                        });
                    },
                    {
                        threshold: 0,
                        root : t.node.querySelector('.wrapper__content'),
                        rootMargin: '0px 200px',
                    }
                );
                t.node.querySelectorAll('.content__item .LazyAsset__item:not(.wrapper__item--loaded)').forEach( ( assetWrapper, index ) => {
                    observerLoad.observe( assetWrapper );
                });
            }
        // -- END -- //
        
    }
    loadContent( pageNum = 1 ) {
        let t = this;
        t.node.setAttribute('data-status','processing');
        t.setUrl( pageNum );

        fetch( window.location.origin + window.location.pathname+'?page_number='+pageNum, {
            method: 'GET'
        })
        .then( ( response ) => {
            return response.text();
        })
        .then( ( html ) => {

            let example = document.createElement( 'div' );
            example.innerHTML = html;

            t.node.querySelector('.row').innerHTML = example.querySelector('.EntriesArchiveGrid[data-reload-id="'+t.node.getAttribute('data-reload-id')+'"] .row').innerHTML;
            window.theme.lazyObj.init();

            t.node.removeAttribute('data-status');

            if( typeof JSModules['PsInit'] != undefined && JSModules['PsInit'] ) {
                t.psObj = new JSModules['PsInit']( t.node );
            }
            
        })
        .catch( ( message ) => {
            t.node.removeAttribute('data-status');
            console.error( message );
        });

    }
    setUrl( pageNum = 1 ) {

        if( pageNum > 1 ) {
            window.history.pushState( {}, '', window.location.origin + window.location.pathname+'?page_number='+pageNum );
        } else {
            window.history.pushState( {}, '', window.location.origin + window.location.pathname );
        }

    }
}
JSModules['EntriesArchiveGrid'] = EntriesArchiveGrid;
export default EntriesArchiveGrid;